import { Component, computed, ElementRef, HostListener, inject, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderNavigationalButtonComponent } from '../../shared/header-navigational-button/header-navigational-button.component';
import { ConfigService } from '../services/config.service';
import { StoreIdService } from '../services/store-id.service';
import { AuthService } from '../services/auth.service';
import { ModalName, ModalService } from '../services/modal.service';
import { TranslocoDirective } from '@ngneat/transloco';
import { FeaturedContent } from '../models/core/featured-content.model';
import { FeaturedContentService } from '../services/featured-content.service';
import { FeaturedContentName } from '../models/core/featured-content-name.enum';
import { IconComponent } from '../../shared/icons/icon.component';
import { IconNameType } from '../../shared/icons/icon-name-type.enum';
import { PremiumService } from '../../loyalty/premium/premium.service';
import { InteractivityChecker } from '@angular/cdk/a11y';

@Component({
  selector: 'cwo-mobile-nav-menu',
  standalone: true,
  imports: [
    CommonModule,
    HeaderNavigationalButtonComponent,
    TranslocoDirective,
    IconComponent,
  ],
  templateUrl: './mobile-nav-menu.component.html',
  styleUrl: './mobile-nav-menu.component.scss',
})
export class MobileNavMenuComponent implements OnInit{
  @ViewChild('menu') menu!: ElementRef<HTMLElement>;

  accountMenuExpanded = false;
  isLoggedIn = computed(() => this.authService.state().isLoggedIn);
  iconName = IconNameType;

  private interactivityChecker = inject(InteractivityChecker);

  modalService = inject(ModalService);
  configService = inject(ConfigService);
  authService = inject(AuthService);
  storeIdService = inject(StoreIdService);

  private featuredContentService = inject(FeaturedContentService);
  headerFeaturedContentLinks: FeaturedContent[] = [];

  configState = this.configService.configState;

  premiumService = inject(PremiumService);

  isMobileSideNavOpen() {
    return this.modalService.isModalOpen(ModalName.MobileSideNav);
  }

  @HostListener('document:keydown.Tab', ['$event'])
  onTabForward(event: Event): void {
    this.cycleFocus(event, false);
  }

  @HostListener('document:keydown.shift.Tab', ['$event'])
  onTabBackward(event: Event): void {
    this.cycleFocus(event, true);
  }

  private cycleFocus(event: Event, backward: boolean): void {
    if (!this.isMobileSideNavOpen()) {
      return;
    }

    const focusable = this.getTabbableElements();
    if (!focusable.length) {
      return;
    }

    event.preventDefault();

    const currentIndex = focusable.indexOf(document.activeElement as HTMLElement);
    const lastIndex = focusable.length - 1;
    const nextIndex = backward
      ? (currentIndex <= 0 ? lastIndex : currentIndex - 1)
      : (currentIndex === -1 || currentIndex === lastIndex ? 0 : currentIndex + 1);

    focusable[nextIndex].focus();
  }

  private getTabbableElements(): HTMLElement[] {
    const toggleButton = document.querySelector<HTMLElement>('.menu-toggle-button');
    const menu = this.menu?.nativeElement;
    const menuTabbable = menu
      ? Array.from(menu.querySelectorAll<HTMLElement>('a[href], button, input, select, textarea, [tabindex]'))
          .filter((el) => this.interactivityChecker.isTabbable(el))
      : [];

    return toggleButton && this.interactivityChecker.isTabbable(toggleButton)
      ? [toggleButton, ...menuTabbable]
      : menuTabbable;
  }

  toggleLoggedIn() {    
    if(!this.isLoggedIn()){
      this.modalService.openModal(ModalName.SignIn);
    } else {
      this.authService.logout().subscribe(() => {
        const pathname = location.pathname.split('/');
        
        window.location.href = `${pathname.length > 0 && `/${pathname[1]}`}/${this.storeIdService.getStorePathPrefix()}`;
      })
    }
  }

  ngOnInit(): void {
    this.headerFeaturedContentLinks = this.featuredContentService.getFeaturedContentsByAreaName(FeaturedContentName.HEADER_LINKS);
  }


  public openStoreSelectionModal(): void {
    this.modalService.closeAllModals().subscribe(
        () => {
          this.modalService.openModal(ModalName.OrderDetails, {
              showStoreChooser: true,
          });
        });
  }
}